module.exports = __webpack_public_path__ + "img/Arrow_Left_400.690ae374.svg";